import '../../scss/pages/b2b.scss';
import '../../scss/variables.scss';
import 'swiper/dist/css/swiper.css';
import Swiper from "swiper";
import {B2bClient} from "../http-clients/B2bClient";
import {CartCountElement} from "../libraries/CartCountElement";

const Carousels = {
    newProductsSlider: null,

    init() {
        const newProductsSliderSelector = '.new-products-slider.swiper-container';
        if (typeof document.querySelector(newProductsSliderSelector) !== 'undefined') {
            Carousels.newProductsSlider = new Swiper(newProductsSliderSelector, {
                slidesPerView: 'auto',
                spaceBetween: 65,
                scrollbar: {
                    el: '.swiper-scrollbar',
                    hide: false,
                },
                breakpoints: {
                    768: {
                        spaceBetween: 30
                    },
                },
                preloadImages: false
            });
        }

        const logosSliderSelector = '.logos-slider.swiper-container';
        if (typeof document.querySelector(logosSliderSelector) !== 'undefined') {
            Carousels.logosSlider = new Swiper(logosSliderSelector, {
                slidesPerView: 'auto',
                spaceBetween: 30,
                scrollbar: {
                    el: '.swiper-scrollbar',
                    hide: false,
                },
                breakpoints: {
                    768: {
                        spaceBetween: 10,
                        slidesPerView: 3,
                        centeredSlides: false,
                    }
                },
                preloadImages: false
            });
        }

        const opinionsSliderSelector = '.opinions-slider.swiper-container';
        if (typeof document.querySelector(opinionsSliderSelector) !== 'undefined') {
            Carousels.logosSlider = new Swiper(opinionsSliderSelector, {
                slidesPerView: 'auto',
                spaceBetween: 30,
                centeredSlides: true,
                centeredSlidesBounds: true,
                initialSlide: 1,
                scrollbar: {
                    el: '.swiper-scrollbar',
                    hide: false,
                },
                breakpoints: {
                    768: {
                        spaceBetween: 10,
                        centeredSlides: false,
                        centeredSlidesBounds: false,
                        initialSlide: 0,
                    }
                },
                preloadImages: false,
            });
        }
    }
};

function validateEmail(x) {
    const filter  = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    if (filter.test(x)) {
        return true;
    } else {
        return false;
    }
}

/**
 * @param {String} nameId
 * @param {boolean} val
 */
function setRequired(nameId, val){
    const input = document.getElementById(nameId).getElementsByTagName('input');
    for(let i = 0; i < input.length; i++){
        input[i].required = val;
        if (val === false) {
            input[i].style.display = 'none';
        } else {
            input[i].style.display = '';
        }
    }
}

function initializeB2bShortEmail() {
    const b2bShortSubmit = document.getElementById('submit-b2b-short-button');

    if (!b2bShortSubmit) {
        return
    }

    b2bShortSubmit.addEventListener('click', (event) => {
        event.preventDefault();

        const client = new B2bClient();
        const modalMessage = document.querySelector('.modal-message');
        modalMessage.style.display = '';

        let data = {};
        document.querySelectorAll('.b2b_short_form').forEach(element => {
            data[element.name] = element.value;
        });

        if (data['captcha'] === '')
        {
            toast.error("Przepisz kod captcha.");
            if (typeof document.getElementsByName('captcha') !== 'undefined') {
                document.getElementsByName('captcha')[0].focus();
            }
        } else if (data['captcha_question'] !== '' && data['captcha'] !== data['captcha_question'])
        {
            toast.error("Kod captcha jest nie poprawny.");
            if (typeof document.getElementsByName('captcha') !== 'undefined') {
                document.getElementsByName('captcha')[0].focus();
            }
        } else if (data['ticket_content'] === '')
        {
            toast.error("Napisz co możemy dla Ciebie zrobić.");
            if (typeof document.getElementsByName('ticket_content') !== 'undefined') {
                document.getElementsByName('ticket_content')[0].focus();
            }
        } else {

            if (data['ticket_mail'].length>0 && validateEmail(data['ticket_mail'])) {

                try {
                    const result = client.send(
                        JSON.stringify(data)
                    ).then((result) => {
                        toast.success(result);

                        if (typeof document.getElementsByName('captcha') !== 'undefined') {
                            document.getElementsByName('captcha')[0].value = '';
                        }
                        document.getElementById('b2b-forms-success').style.display = '';
                        document.getElementById('b2b-short-forms').style.display = 'none';
                        location.hash = "#b2b_forms";
                    });
                } catch (error) {
                    toast.error("Błąd podczas wysyłki danych");
                }

            } else {
                toast.error("Wpisz poprawnie adres email");
                if (typeof document.getElementsByName('ticket_mail') !== 'undefined') {
                    document.getElementsByName('ticket_mail')[0].focus();
                }
            }

        }

        modalMessage.style.display = 'none';
        return false;
    });
}

function initializeB2bForm() {

    if (typeof document.getElementsByName('b2b_radio_has_product') !== 'undefined') {
        const radioProductSection = document.getElementsByName('b2b_radio_has_product');
        for (let i = 0; i < radioProductSection.length; i++) {
            radioProductSection[i].onclick = function() {
                if (this.value === 'tak') {
                    document.getElementById('questions_02').style.display = '';
                    document.getElementById('b2b-question2-forms').style.display = 'none';
                    document.getElementById('b2b-contact-forms').style.display = 'none';
                    document.getElementById('b2b-your-move').style.display = 'none';

                    setRequired('b2b-question2-forms', false);
                    setRequired('b2b-contact-forms', false);

                } else {
                    document.getElementById('questions_02').style.display = 'none';
                    document.getElementById('b2b-your-move').style.display = '';

                    document.getElementById('b2b-question-forms').style.display = 'none';
                    document.getElementById('b2b-question2-forms').style.display = '';
                    document.getElementById('b2b-contact-forms').style.display = '';

                    setRequired('b2b-question-forms', false);
                    setRequired('b2b-question2-forms', true);
                    setRequired('b2b-contact-forms', true);

                    const radioPersonalizeSection = document.getElementsByName('b2b_radio_personalize');
                    for (let i = 0; i < radioPersonalizeSection.length; i++) {
                        radioPersonalizeSection[i].checked = false;
                    }
                }
            }
        }
    }

    if (typeof document.getElementsByName('b2b_radio_has_product') !== 'undefined') {
        const radioPersonalizeSection = document.getElementsByName('b2b_radio_personalize');
        for (let i = 0; i < radioPersonalizeSection.length; i++) {
            radioPersonalizeSection[i].onclick = function() {
                if (this.value === 'tak') {
                    document.getElementById('questions_04').style.display = '';
                } else {
                    document.getElementById('questions_04').style.display = 'none';
                }
                document.getElementById('b2b-question-forms').style.display = '';
                document.getElementById('b2b-question2-forms').style.display = '';

                setRequired('b2b-question-forms', true);
                setRequired('b2b-question2-forms', true);

                document.getElementById('b2b-your-move').style.display = '';
                document.getElementById('b2b-contact-forms').style.display = '';

                setRequired('b2b-contact-forms', true);
            }
        }
    }
}

function initialize() {

    Carousels.init();

    initializeB2bShortEmail();
    initializeB2bForm();
}

initialize();
